import { render, staticRenderFns } from "./UpdateProductGeneralInfo.vue?vue&type=template&id=0da3c2e3&scoped=true"
import script from "./UpdateProductGeneralInfo.vue?vue&type=script&lang=js"
export * from "./UpdateProductGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateProductGeneralInfo.vue?vue&type=style&index=0&id=0da3c2e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da3c2e3",
  null
  
)

export default component.exports